import axios from 'axios';
import getUrl from 'utils/getUrl';
import {
  generateTakerRejection,
  getErrorType,
  getRejectionError,
} from './utils/takerApiUtils';

const recordNotFoundErrorType = 'RecordNotFound';

const suppressNotFoundQuestionError = rejection => {
  const error = getRejectionError(rejection.response.data);

  if (error && getErrorType(error) === recordNotFoundErrorType) {
    return;
  }

  return Promise.reject(rejection);
};

export default ({ responseUuid, answer, questionId }) =>
  axios
    .post(
      getUrl.api(`response/${responseUuid}/question/${questionId}/answer`),
      answer,
    )
    .catch(suppressNotFoundQuestionError)
    .catch(generateTakerRejection());
